import React, { useEffect, useState } from "react";
import fileDownload from "js-file-download";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import { get, getFile } from "../../../../api";
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function Payout() {
  const [payOutType, setPayOutType] = useState("month");
  const [payOut, setPayOut] = useState({
    labels: [],
    datasets: [
      {
        label: "Pay Out",
        data: [],
        fill: true,
        backgroundColor: "rgba(75,192,192,0.2)",
        borderColor: "rgba(75,192,192,1)",
      },
    ],
  });
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };
  useEffect(() => {
    getPayOut(false);
  }, []);
  const getPayOut = async (isDownload = false, type) => {
    // type = week/month
    try {
      let url = `/meeting-timesheet/report/pay-out?type=${
        type ? type : payOutType
      }&download=${isDownload}`;
      let response;
      if (isDownload) {
        response = await getFile(url);
      } else {
        response = await get(url);
      }
      let labels = [];
      let data = [];
      if (isDownload && response?.data) {
        fileDownload(
          response?.data,
          response?.headers?.["content-disposition"]?.split("filename=")[1]
        );
      }
      if (!isDownload && response?.count) {
        for (const [key, value] of Object.entries(response?.count)) {
          labels.push(key);
          data.push(value);
        }
        setPayOut({
          labels: labels,
          datasets: [
            {
              label: "Pay out",
              data: data,
              fill: true,
              backgroundColor: "rgba(75,192,192,0.2)",
              borderColor: "rgba(75,192,192,1)",
            },
          ],
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div className="widget-title">
        <h4>Pay out</h4>
        <div className="chosen-outer">
          {/* <!--Tabs Box--> */}
          <select className="chosen-select-payoutsite">
            <option>All sites</option>
            <option>Site A</option>
            <option>Site B</option>
          </select>
          <select
            className="chosen-select-payoutmonth"
            onChange={(e) => {
              e?.stopPropagation();
              setPayOutType(e?.target?.value);
              getPayOut(false, e?.target?.value);
            }}
          >
            <option value={"month"}>Last 6 Months</option>
            <option value={"week"}>Last 24 Weeks</option>
          </select>
          <div>
            <button
              type="button"
              className="theme-btn btn-sm btn-style-three"
              onClick={(e) => {
                e?.stopPropagation();
                getPayOut(true);
              }}
            >
              Download
            </button>
          </div>
        </div>
      </div>

      <div className="widget-content">
        <Line data={payOut} options={options} />
      </div>
    </>
  );
}

export default Payout;
